<template>
    <div
        v-if="item"
        class="partial-card"
        @click="openPath"
    >
        <div
            class="partial-card__container"
            :class="`partial-card__container--${variant}`"
        >
            <p
                class="partial-card__container__category"
                v-if="item.category"
                v-html="item.category"
            />
            <h3
                v-if="item.title"
                class="partial-card__container__title"
                :class="item.summary ? '' : 'partial-card__container__title--no-summary'"
            >
                <span v-html="item.title" />
            </h3>
            <p
                class="partial-card__container__summary"
                v-if="item.summary"
                v-html="item.summary"
            />
            <template v-if="item.src">
                <a
                    @click="openPath"
                >
                    {{ item.label ? item.label : 'Discover' }}
                </a>
            </template>
            <template v-else>
                <span>{{ item.label ? item.label : 'Discover' }}</span>
            </template>
        </div>
    </div>
</template>

<script>
import Navigation from "@/services/navigation";

export default {
    props: {
        item: Object,
        variant: {
            type: String,
            default: 'beta',
        }
    },

    methods: {
        openPath(){
            if(this.item.src){
                if(this.item.src.indexOf('http') > -1){
                    window.open(this.item.src)
                } else {
                    Navigation.push(this.item.src)
                }
            }
        }
    }
}
</script>

<style>
.partial-card {
    @apply flex flex-col h-full flex-grow text-cod-gray cursor-pointer;

    &__container {
        @apply flex flex-col p-6 bg-white lg:h-full w-full mb-8;

        &__category {
            @apply text-spaced-small text-xs mb-4 font-semibold;
        }

        &__title {
            @apply text-base cursor-pointer mb-2;

            span {
                @apply title-underline;
            }

            &--no-summary {
                @apply mb-8 lg:flex-grow lg:mb-12;
            }
        }

        &__summary {
            @apply font-goudy leading-relaxed mb-8 lg:flex-grow lg:mb-12;
        }

        > a {
            @apply text-spaced-small hover:text-cod-gray underline cursor-pointer w-max font-semibold;
        }

        > span {
            @apply text-spaced-small hover:text-cod-gray underline w-max font-semibold;
        }
    }
}
</style>
